
import { Grid } from "@mui/material";
import DialogFullScreen from "../../../../../components/DialogFullScreen";
import CardResumo from "./CardResumo";
import CardValores from "./CardValores";
import CardSituacaoPedido from "./CardSituacaoPedido";
import CardItens from "./CardItens";
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import { IDataDetalharPedido, TPagamentoDetalhes } from "../../../../../types/api/comercial/detalhar-pedido";
import CardHistoricoExpedicao from "./CardHistoricoExpedicao";
import { FormProvider, useForm } from "react-hook-form";
import { TEditForm } from "./EditarPagamento";
import {
    IInternFormCheckout
} from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/Checkout/FormasPagamento/DialogCadastrarValor";
import { formatarDecimalNumber } from "../../../../../helpers/masks";
import { AxiosResponse } from "axios";
import { ConfirmProvider } from "material-ui-confirm";

export default function DialogDetalhePedido({
    open,
    value,
    handleClose
}: DialogDetalhePedidoProps) {
    //querys e mutations
    const { data, isLoading } = useQuery({
        queryKey: [`comercial/detalhar-pedido`, value],
        queryFn: () => axiosClient.get("/comercial/detalhar-pedido", {
            params: { codigo: value }
        }),
        onSuccess: (data: AxiosResponse<TDataQuery>) => {
            const detalhe = data.data;
            if (detalhe) {
                reset({
                    ...detalhe,
                    sub_total: detalhe.subtotal,
                    valoresAdicionados: transformFormaRecebimento(detalhe.pagamentos) || [],
                    valor_frete: String(detalhe.frete),
                    valor_restante: Number((detalhe.subtotal + detalhe.frete - detalhe.descontos).toFixed(2)),
                    itens: detalhe.itens.map((item) => ({
                        ...item,
                        id: String(item.id),
                        produto_id: String(item.produto_id),
                        praga: item.praga || undefined,
                        cultura: item.cultura || undefined
                    })),
                    lojas_ids: detalhe.itens.map((item) => item.loja.id),
                    condicao_pagamento: transformCondicaoPagamento(detalhe),
                    selected_fazenda: detalhe.fazenda,
                });
            }
        },
        cacheTime: 0
    });
    const detalhe: TDataQuery = data?.data || null;

    const methods = useForm<TEditForm>({
        defaultValues: {},
    });
    const { reset } = methods;

    return (
        <DialogFullScreen
            {...{ open, handleClose }}
            title="Detalhe do pedido"
        >
            {isLoading && <LoadingApiQuery />}

            {
                (!isLoading && detalhe) &&
                <FormProvider {...methods}>
                    <Grid container spacing={2}>
                        <Grid container size={{xs: 12, md: 4}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs: 12}}>
                                <CardResumo data={detalhe} />
                            </Grid>

                            <Grid size={{xs: 12}}>
                                <CardValores data={detalhe} />
                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, md: 8}} spacing={2} alignSelf="flex-start">
                            <Grid size={{xs: 12}}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Cancelar pedido',
                                    cancellationText: "Fechar",
                                    confirmationText: "Cancelar",
                                    confirmationButtonProps: { variant: 'contained', color: 'error' }
                                }}>
                                    <CardSituacaoPedido
                                        data={detalhe}
                                    />
                                </ConfirmProvider>
                            </Grid>
                            {
                                (detalhe.situacao === "Expedição" || detalhe.situacao === "Finalizado") &&
                                <Grid size={{xs: 12}}>
                                    <CardHistoricoExpedicao data={detalhe} />
                                </Grid>
                            }
                            <Grid size={{xs: 12}}>
                                <CardItens
                                    data={detalhe}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            }

        </DialogFullScreen>
    )
}

function transformCondicaoPagamento(data: any) {
    if (!data.condicao_pagamento) return null;
    return {
        id: data.condicao_pagamento.id,
        nome: data.condicao_pagamento.nome,
        taxa: Number(data.condicao_pagamento.taxa),
        status: data.condicao_pagamento.status,
        parametros: data.condicao_pagamento.parametros,
        alertas: data.condicao_pagamento.alertas || [],
        formas_recebimento: data.condicao_pagamento.formas_recebimento || [],
    };
}

function transformFormaRecebimento(pagamentos: TPagamentoDetalhes[]): IInternFormCheckout[] {
    const result: any[] = [];
    pagamentos.forEach((item: any) => {
        result.push({
            condicao_pagamento: item.condicao_pagamento,
            forma_recebimento: {
                ...item.forma_recebimento,
                flg_possui_parcelas: item.forma_recebimento.flg_possui_parcelas === "S" ? 1 : 0,
                flg_usa_cartao: item.forma_recebimento.flg_usa_cartao === "S" ? 1 : 0,
                flg_usa_cheque: item.forma_recebimento.flg_usa_cheque === "S" ? 1 : 0,
            },
            pagamento_id: item.id,
            pagamento: item.parametros,
            status: item.status,
            valor: String(formatarDecimalNumber(item.valor))
        });
    });
    return result;
}

interface DialogDetalhePedidoProps {
    open: boolean,
    handleClose: () => void,
    value: string
}

export interface CardProps {
    data: IDataDetalharPedido
}

type TDataQuery = IDataDetalharPedido | null